import { apiRequest } from "../../../../shared/api/client";
import type {
  SpecialistDecisionGateway,
  SpecialistDecisionInput,
} from "../../application/commands/submit-specialist-decision";

export const procurementCommandGateway: SpecialistDecisionGateway = {
  saveRecommendation<TRecommendation>(input: SpecialistDecisionInput) {
    return apiRequest<TRecommendation>(
      `/api/evaluations/${encodeURIComponent(input.evaluationId)}/recommendation`,
      {
        method: "POST",
        body: JSON.stringify({
          decisionType: input.decisionType,
          offerId: input.offerId,
          rationale: input.rationale,
        }),
      },
    );
  },
  async routeToManager(requestNo: string) {
    await apiRequest(
      `/api/requests/${encodeURIComponent(requestNo)}/route-approval`,
      { method: "POST" },
    );
  },
};
